const brands = [
  { brand: "PQI", color: "#004C97" },
  { brand: "Axiomtek", color: "#7C001A" },
  { brand: "Orange", color: "#FF7900" },
  { brand: "SFR", color: "#E2001A" },
  { brand: "Enforain", color: "#666666" },
  { brand: "Inconnu", color: "#AAAAAA" },
  { brand: "Bouygues", color: "#009FE3" },
  { brand: "Sandisk", color: "#D6001C" },
  { brand: "Enfora", color: "#666666" },
  { brand: "ON SEMICONDUCTOR", color: "#00A859" },
  { brand: "TYCO", color: "#003366" },
  { brand: "MICROCHIP", color: "#CC0000" },
  { brand: "ECHELON", color: "#005B96" },
  { brand: "KELTA", color: "#888888" },
  { brand: "ASTEEL", color: "#0072BB" },
  { brand: "SERCOMM", color: "#009999" },
  { brand: "TELIT", color: "#003366" },
  { brand: "ATMEL", color: "#1F75CC" },
  { brand: "KEYMOS", color: "#666666" },
  { brand: "MXIC", color: "#E60012" },
  { brand: "NANYA", color: "#005BAC" },
  { brand: "STAR", color: "#FFD700" },
  { brand: "SPANSION", color: "#68217A" },
  { brand: "CAVIUM", color: "#003366" },
  { brand: "INFINEON", color: "#E20074" },
  { brand: "HONGFA", color: "#005BAC" },
  { brand: "Coronis", color: "#0088CC" },
  { brand: "STMICROELECTRONICS", color: "#0066CC" },
  { brand: "OMRON", color: "#005BAB" },
  { brand: "TEMPer", color: "#999999" },
  { brand: "CIRCUTOR", color: "#8B0032" },
  { brand: "MCI", color: "#0077B5" },
  { brand: "ST", color: "#0066CC" },
  { brand: "ESMT", color: "#4B4B4B" },
  { brand: "Philio", color: "#3D91C8" },
  { brand: "Quectel", color: "#E60012" },
  { brand: "Huawei", color: "#D7000F" },
  { brand: "Aztech", color: "#0072BB" },
  { brand: "Sierra Wireless", color: "#E41E26" },
  { brand: "UNFREEZE", color: "#00AEEF" },
  { brand: "Dekimo", color: "#0083CA" },
  { brand: "Silabs", color: "#E03C31" },
  { brand: "HDL", color: "#6F2DA8" },
  { brand: "KPN", color: "#009A49" },
  { brand: "MATELEC", color: "#0033A0" },
  { brand: "Netatmo", color: "#00B2FF" },
  { brand: "Telefonica", color: "#0066A1" },
  { brand: "Vodafone", color: "#E60000" },
  { brand: "O2", color: "#002D72" },
  { brand: "EpiSensor", color: "#00A99D" },
];

export class BrandService {
  public findSpecificBrandColor(brandName?: string | null): string | undefined {
    if (!brandName) {
      return undefined;
    }

    for (const brandItem of brands) {
      if (brandItem.brand.toLowerCase() === brandName.toLowerCase().trim()) {
        return brandItem.color;
      }
    }

    return undefined;
  }
}
